<template>
  <div class="addressContent">
    <titlebar
      titleName="收货地址"
      goback="true"
      :rightTitle="title2"
      @edit="edit"
    ></titlebar>
    <div class="content">
      <ul>
        <li class="item" v-for="(item, index) in 18" :key="index">
          <div class="left">
            <div class="top">
              <p>测试员</p>
              <p>13233548895</p>
            </div>
            <div class="bottom">
              <span>默认</span>
              <p>广东省广州市天河区科韵路金豪商务大厦6303</p>
            </div>
          </div>
          <van-icon size="1rem" name="arrow" v-if="title2 == '编辑'" />
          <div v-else class="delet">删除</div>
        </li>
      </ul>
      <div class="btn">新增地址</div>
    </div>
  </div>
</template>

<script>
import titlebar from "../../components/index/titleBar.vue";
export default {
  components: {
    titlebar,
  },
  data() {
    return {
      title2: "编辑",
    };
  },
  methods: {
    edit(index) {
      this.title2 = index;
    },
  },
};
</script>

<style lang="less"  scoped>
.content {
  padding-top: 13vw;
  padding-bottom: 13vw;
  .btn {
    width: 70.5333vw;
    height: 10.2667vw;
    background: #ffa623;
    color: #fff;
    line-height: 10.2667vw;
    text-align: center;
    border-radius: 5vw;
    position: fixed;
    bottom: 1%;
    left: 50%;
    transform: translateX(-50%);
  }
  ul {
    .item {
      width: 92vw;
      height: 18.6667vw;
      background: #fff;
      border-radius: 3vw;
      margin: 2vw auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 2.9333vw;
      .delet {
        width: 12.6667vw;
        height: 7.2vw;
        line-height: 7.2vw;
        font-size: 3.5vw;
        background: #ffa623;
        color: #fff;
      }
      .left {
        color: #000;
        .top {
          display: flex;
          align-items: center;
          :first-child {
            font-size: 4.5vw;
            font-weight: 600;
            margin-right: 4vw;
          }
          :last-child {
            font-size: 4vw;
          }
        }
        .bottom {
          display: flex;
          align-items: center;
          margin-top: 2.1333vw;
          span {
            background: #ffa623;
            color: #fff;
            font-size: 3vw;
            padding: 0 1vw;
            border-radius: 1vw;
          }
          p {
            width: 60vw;
            margin-left: 4vw;
            font-size: 3.5vw;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>